/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuConfigurationsResponse } from '../../models/menu-configurations-response';

export interface PublishConfigsGet$Params {
  'Active-Tenant-Identifier': string;
}

export function publishConfigsGet(http: HttpClient, rootUrl: string, params: PublishConfigsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuConfigurationsResponse>> {
  const rb = new RequestBuilder(rootUrl, publishConfigsGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuConfigurationsResponse>;
    })
  );
}

publishConfigsGet.PATH = '/publish-configs';
